export default __webpack_public_path__ + "static/media/tf_tagline.aaa113e4.png";